/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2022-11-14 10:11:32
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-16 16:55:15
 */
import Layout from '@/layout'
export default [
  {
    path: '/exam',
    name: 'Exam',
    component: Layout,
    redirect: '/exam/plan',
    meta: { level: 1, title: '考试中心', icon: 'el-icon-monitor' },
    children: [
      {
        path: 'plan',
        name: 'ExamPlan',
        component: () => import(/*webpackChunkName:'ExamPlan'*/ '@/views/exam/ExamPlan/index'),
        meta: { title: '考试计划', keepAlive: true },
      },
      {
        path: 'plan/add',
        hidden: true,
        name: 'ExamPlanAdd',
        component: () => import(/*webpackChunkName:'ExamPlanAdd'*/ '@/views/exam/ExamPlan/add'),
        meta: { title: '创建考试计划' },
      },
      {
        path: 'plan/read/:id',
        hidden: true,
        name: 'ExamPlanRead',
        component: () => import(/*webpackChunkName:'ExamPlanRead'*/ '@/views/exam/ExamPlan/add'),
        meta: { title: '查看考试计划' },
      },
      {
        path: 'plan/:id',
        hidden: true,
        name: 'ExamPlanEdit',
        component: () => import(/*webpackChunkName:'ExamPlanEdit'*/ '@/views/exam/ExamPlan/add'),
        meta: { title: '创建考试计划' },
      },
      {
        path: 'paper',
        name: 'ExamPaper',
        component: () => import(/*webpackChunkName:'ExamPaper'*/ '@/views/exam/ExamPaper/index'),
        meta: { title: '考试试卷', keepAlive: true },
      },
      {
        path: 'paper/add',
        hidden: true,
        name: 'ExamPaperAdd',
        component: () => import(/*webpackChunkName:'ExamPaperAdd'*/ '@/views/exam/ExamPaper/add'),
        meta: { title: '添加考试试卷' },
      },
      {
        path: 'paper/design',
        hidden: true,
        name: 'ExamPaperDesign',
        component: () =>
          import(/*webpackChunkName:'ExamPaperDesign'*/ '@/views/exam/ExamPaper/design/index'),
        meta: { title: '自定义试题' },
      },
      {
        path: 'paper/config',
        hidden: true,
        name: 'ExamPaperConfig',
        component: () =>
          import(/*webpackChunkName:'ExamPaperConfig'*/ '@/views/exam/ExamPaper/config'),
        meta: { title: '配置试卷' },
      },
      {
        path: 'paper/:id',
        hidden: true,
        name: 'ExamPaperEdit',
        component: () => import(/*webpackChunkName:'ExamPaperEdit'*/ '@/views/exam/ExamPaper/add'),
        meta: { title: '编辑考试试卷' },
      },
      {
        path: 'testPaper',
        hidden: true,
        name: 'testPaper',
        component: () =>
          import(/*webpackChunkName:'ExamPaperEdit'*/ '@/views/exam/ExamPaper/testPaper'),
        meta: { title: '测试' },
      },
      {
        path: 'mark',
        name: 'ExamMark',
        component: () => import(/*webpackChunkName:'ExamResult'*/ '@/views/exam/ExamCheck/index'),
        meta: { title: '考试阅卷', keepAlive: true },
      },
      {
        path: 'mark/detail',
        hidden: true,
        name: 'ExamMarkDetail',
        component: () =>
          import(/*webpackChunkName:'ExamPaperEdit'*/ '@/views/exam/ExamCheck/detail'),
        meta: { title: '阅卷详情' },
      },
      {
        path: 'result',
        name: 'ExamResult',
        component: () => import(/*webpackChunkName:'ExamResult'*/ '@/views/exam/ExamResult/index'),
        meta: { title: '考试成绩', keepAlive: true },
      },
      {
        path: 'result/detail',
        hidden: true,
        name: 'ExamResultDetail',
        component: () =>
          import(/*webpackChunkName:'ExamPaperEdit'*/ '@/views/exam/ExamResult/detail'),
        meta: { title: '考试详情' },
      },
      {
        path: 'questionStore',
        name: 'QuestionStore',
        component: () =>
          import(/*webpackChunkName:'QuestionStore'*/ '@/views/exam/QuestionStore/index'),
        meta: { title: '题库管理', keepAlive: true },
      },
      {
        path: 'questionStore/detail',
        hidden: true,
        name: 'QuestionStoreDetail',
        component: () =>
          import(/*webpackChunkName:'QuestionStore'*/ '@/views/exam/QuestionStore/detail'),
        meta: { title: '题库详情' },
      },
      {
        path: 'questionStore/design',
        hidden: true,
        name: 'QuestionStoreDesign',
        component: () =>
          import(/*webpackChunkName:'ExamPaperDesign'*/ '@/views/exam/QuestionStore/design'),
        meta: { title: '编辑试题' },
      },
    ],
  },
]
